import type { DefaultTheme } from 'styled-components';
import { lightColors, mapLightTheme } from './LightTheme';

export const LightNeoChainTheme: DefaultTheme = mapLightTheme(lightColors, {
  name: 'LightNeoChain',
});
